import Controller from 'controllers/controller';
import Helpers from 'tools/helpers';
import Animator from 'tools/animator';

class AudioPlayerController extends Controller {
    constructor(app, player) {
        super(app);

        this.player = player;
        this.elements = { };
        this.animator = new Animator({
            elements: this.elements
        });

        this.cacheElements();
        this.attachEvents();
    }

    cacheElements() {
        this.elements.player = this.player;
        this.elements.audio = this.player.querySelector('audio');
        this.elements.button = this.player.querySelector('.play-button');
        this.elements.progress = this.player.querySelector('.progress');
        this.elements.progressHandle = this.player.querySelector('.progress-handle');
        this.elements.duration = this.player.querySelector('.duration');
    }

    attachEvents() {
        this.app.audioPlayersController.bus.on('audio-playing', this.onAudioPlaying);
        this.elements.button.addEventListener('click', this.onClick);
        this.elements.audio.addEventListener('ended', this.onFinish);
        this.elements.progress.addEventListener('click', this.onSeek, { passive: true });
        this.elements.audio.addEventListener('timeupdate', Helpers.throttledFunction(500, this.onTimeUpdate), { passive: true });
    }

    onAudioPlaying(instance) {
        if (instance !== this && ! this.elements.audio.paused) {
            this.togglePlay();
        }
    }

    onClick() {
        this.togglePlay();
    }

    togglePlay() {
        let container = this.player,
            audio = this.elements.audio;

        this.updateProgressBar();
        
        if ( ! container.classList.contains('show-controls')) {
            container.classList.add('show-controls');
        }

        if (audio.paused) {
            audio.play();
            container.classList.add('currently-playing');
            
            this.app.audioPlayersController.bus.emit('audio-playing', this);
        } else {
            container.classList.remove('currently-playing');
            audio.pause();
        }
    }

    onFinish() {
        this.player.classList.remove('show-controls');
        this.player.classList.remove('currently-playing');
    }

    onSeek(event) {
        let percentage,
            audio = this.elements.audio,
            progress = this.elements.progress;

        percentage = event.offsetX / progress.offsetWidth;
        audio.currentTime = percentage * audio.duration;
    }

    onTimeUpdate(event) {
        this.updateProgressBar();
    }

    updateProgressBar() {
        let progressPercentage,
            audio = this.elements.audio,
            progress = this.elements.progress,
            duration = this.elements.duration;

        progressPercentage = audio.currentTime / audio.duration;
        
        this.animator.set('progressHandle', {
            x: `${-(1-progressPercentage) * 100}%`
        });
        
        duration.innerHTML = this.formatTime(audio.currentTime);
    }

    formatTime(sec) {
        let hrs = Math.floor(sec / 3600),
            min = Math.floor((sec - (hrs * 3600)) / 60),
            seconds = sec - (hrs * 3600) - (min * 60),
            result;

        seconds = Math.floor(Math.round(seconds * 100) / 100);
        
        // result = (hrs < 10 ? "0" + hrs : hrs);
        // result += ":" + (min < 10 ? "0" + min : min);
        result = `${min < 10 ? '0' + min : min}`;
        result += `:${seconds < 10 ? '0' + seconds : seconds}`;

        return result;
    }
}

export default AudioPlayerController;